import { Core } from "@faire/design-tokens";
import pointOfSale from "@faire/web-api/routes/point-of-sale";
import { Button } from "@faire/web/slate/Button";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";

export const POSFooterBanner: React.FC = () => (
  <Container>
    <Typography variant="pageHeaderSerifRegular">
      <StrictLocalMsg
        defaultMessage="Save time by linking your POS system on Faire"
        description={{ text: "POS = point of sale" }}
      />
    </Typography>
    <Spacer size="3x" />
    <Button
      variant="secondary"
      linkTo={pointOfSale()}
      style={{ minWidth: "200px" }}
    >
      <StrictLocalMsg
        defaultMessage="Get Started"
        description={{
          text: "Call to action to start linking your inventory to Faire",
        }}
      />
    </Button>
  </Container>
);

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  align-items: stretch;
  justify-content: flex-start;
  border-top: 1px solid ${Core.border.muted};
  padding: 32px 24px;

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 30px 96px 60px;
    border-top-color: transparent;
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    max-width: 429px;
    padding: 24px 96px 60px 0;
    align-items: flex-end;
  }

  ${responsiveMediaQueries.xLargeAndAbove} {
    max-width: 600px;
  }
`;
